export enum Currency {
	Default = 0,
	EUR = 1,
	CHF = 2,
	SEK = 3,
	GBP = 4,
}
